<template>
  <div class="container">
    <header class="jumbotron">
      <h1>{{ team }}</h1>
      <div>
        {{ selected && selected.length }} deltakere<br>
        {{ this.content.num_participants_events }} opprop totalt<br>
        {{ this.content.num_participants_events_today }} opprop i dag<br>
        {{ this.content.num_participants_events_after_today }} opprop kommende dager<br>
        {{ this.content.num_participants_events_before_today }} opprop tidligere dager<br>
      </div>
    </header>
    <div class="list row">
      <div class="col-md-6">
        <div>
          <div>
            <div>Dagens opprop</div>
            <!-- <span>({{ this.content.event_participant && this.content.event_participant.length }} opprop)</span> -->
          </div>
          <div class="table">
            <div class="row">
                <div class="cell header">Utøver</div>
                <div class="cell header">Øvelse</div>
                <div class="cell header">Øvelsetid</div>
                <div class="cell header">Oppropstidspunkt</div>
                <div class="cell header">Status</div>
            </div>
            <!-- <div class="row list-group-item-secondary" -->
            <div class="row" :class="{
                'list-group-item-secondary': event_participant.passedcheck == -1, 
                'list-group-item-info': event_participant.passedcheck == 1 }"
              v-for="(event_participant, index) in this.content.event_participant" :key="index"
              @click="setActiveTeam(event_participant, index)">
              <div class="cell" :class="alert_status_class(event_participant)">
                {{ event_participant.participant_bib }} - {{ event_participant.participant_name }}<small
                  hidden="hidden">(Id:{{
                    event_participant.participant_id }})</small>
              </div>
              <div class="cell">{{ event_participant.event }} ({{ event_participant.event_agegroup }})<small hidden="hidden">(Id:{{ event_participant.event_id }})</small></div>
              <div class="cell">{{ event_participant.event_time | formatDate_onlyHourIfToday }}</div>
              <div class="cell">{{ event_participant.event_callroomregistration_time | formatDate_onlyHourIfToday }}</div>
              <div class="cell">
                <span :class="pill_status_class(event_participant)"
                  >{{ !event_participant.event_callroomstatus 
                    ? ( !event_participant.event_callroomstatus_modificationtime 
                        ? 'Ikke avkrysset' 
                        : 'Trukket'
                      ) 
                    : event_participant.event_callroomstatus 
                    ? "Avkrysset" 
                    : (
                        (event_participant.callroomregistration_closed_time == '2020-01-01T00:00:00' 
                        || event_participant.callroomregistration_closed_time == "2019-12-31T23:00:00.000Z") 
                        ? "Ikke opprop for øvelse" 
                        : "Ikke avkrysset"
                      ) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <ul class="list-group">
          <li class="list-group-item" :class="{ active: index == currentIndex }"
            v-for="(participant, index) in this.content.event_participant" :key="index"
            @click="setActiveTeam(participant, index)">
            <div>
              {{ participant.participant_bib }} - {{ participant.participant_name }} <small hidden="hidden">(Id:{{
                participant.participant_id }})</small> - {{ participant.participant_team }}
              <a class="badge badge-success float-right" :href="'/team/' + encodeURIComponent(team)">
                Vis lag
              </a>
            </div>
          </li>
        </ul> -->
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/user.service';

export default {
  name: 'Teams',
  data() {
    return {
      content: '',
      events: '',
      selected: '',
      team: '',
      currentTeam: null,
      currentIndex: -1,
      debug: false,
      now: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.now = new Date();
    this.getData();
  },
  methods: {
    async getEventData(competition_id) {
    await UserService.getEventsBoard(competition_id).then(
    // async getEventData(competition_id, team) {
    // await UserService.getTeamBoard(competition_id, team).then(
      // let response = await UserService.getEventsBoard(competition_id);
      // console.log(response);
      
        response => {
          var all = [];
          var passed = [];
          var current = [];
          var future = [];
          response.data.events.forEach(event => {
            all.push(event);
            if (this.isPassedTime(event.event_time)) {
              passed.push(event);
            } else {
              if (this.isPassedTime(event.callroomregistration_closed_time)) {
                if (new Date(event.callroomregistration_closed_time) < new Date("2020-01-01T01:00:00")) {
                  passed.push(event);
                } else {
                  current.push(event);
                }
              } else {
                future.push(event);
              }
            }
          });
          response.data.all = all || [];
          response.data.passed = passed || [];
          response.data.current = current || [];
          response.data.future = future || [];
          this.events = response.data;
          return;
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          return;
        }
      );
    },
    async getData() {
      let competition_id = this.$route.params.competition_id;
      // console.log("competition_id");
      // console.log(competition_id);
      await this.getEventData(competition_id);
      if (this.$route.params.teamname) {
        this.team = decodeURIComponent(this.$route.params.teamname)
      }
      await this.getEventData(competition_id);
      // await this.getEventData(competition_id, this.team);
      UserService.getParticipantsBoard(competition_id).then(
        response => {
          const uniqueSet = new Set();
          response.data.participants.forEach(item => {
            uniqueSet.add(item.participant_team);
          });
          response.data.teams = Array.from(uniqueSet);
          this.content = response.data;
          var selected = [];
          var arr_all_event_participant = [];
          var num_participants_events = 0;
          var num_participants_events_today = 0;
          var num_participants_events_before_today = 0;
          var num_participants_events_after_today = 0;
          response.data.participants.forEach(participant => {
            if (participant.participant_team == this.team) {
              selected.push(participant)
              participant.events.forEach(event => {
                var event_participant;
                // Need to kopi all data, not by reference
                event_participant = {
                    ... participant
                }
                delete event_participant.events;

                num_participants_events++;
                // console.log("this.events");
                // console.log(this.events);
                // console.log("this.events.all");
                // console.log(this.events.all);
                const foundevent = this.events.all.find(item => item.event_id === event.event_id)
                // console.log(foundevent.event_id)
                // console.log(foundevent.event_time)
                // var event_time = new Date(foundevent.event_time);
                if (!foundevent) return;
                var callroomregistration_time = new Date(foundevent.callroomregistration_time);
                event_participant.event = foundevent.event;
                event_participant.event_id = foundevent.event_id;
                event_participant.event_agegroup = foundevent.agegroup;
                event_participant.event_time = foundevent.event_time;
                event_participant.event_callroomstatus = event.callroomstatus;
                event_participant.event_callroomstatus_modificationtime = event.callroomstatus_modificationtime;
                // if ( event_callroomstatus == undefined ) {
                //   event_participant.event_callroomstatus_not_set                    
                // }
                event_participant.event_callroomregistration_time = foundevent.callroomregistration_time;
                event_participant.event_callroomregistration_closed_time = foundevent.callroomregistration_closed_time;
                event_participant.event_callroomregistration_open_time = foundevent.callroomregistration_open_time;
                if (this.isSameDay(callroomregistration_time, this.now)) {
                  num_participants_events_today++;
                  if ( new Date ( event_participant.event_callroomregistration_time) < this.now) {
                    event_participant.passedcheck = -1
                  } else {
                    event_participant.passedcheck = 0
                  }
                } else {
                  if (callroomregistration_time < this.now) {
                    num_participants_events_before_today++;
                    event_participant.passedcheck = -1
                  } else {
                    num_participants_events_after_today++;
                    event_participant.passedcheck = 1
                  }
                }
                arr_all_event_participant.push(event_participant);
              })
            }
          });
          this.selected = selected;
          // Sorting the array by the 'event_time' field in ascending order
          arr_all_event_participant.sort((a, b) => new Date(a.event_time) - new Date(b.event_time));

          this.content.num_participants_events = num_participants_events;
          this.content.num_participants_events_today = num_participants_events_today;
          this.content.num_participants_events_before_today = num_participants_events_before_today;
          this.content.num_participants_events_after_today = num_participants_events_after_today;
          this.content.event_participant = arr_all_event_participant;
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      )
    },
    setActiveTeam(team, index) {
      this.currentTeam = team;
      this.currentIndex = index;
    },
    isPassedTime(time) {
      time = new Date(time)
      if (Date.parse(time) < new Date()) {
        return true;
      } else {
        return false;
      }
    },
    isSameDay(date1, date2) {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      )
    },
    status_class(event_participant) {
      // No callroom close time
      // console.log("event_participant");
      // console.log(event_participant);
      if (event_participant.event_callroomregistration_time == "Ikke opprop for øvelse"
        || event_participant.event_callroomregistration_closed_time == "2020-01-01T00:00:00"
        || event_participant.event_callroomregistration_closed_time == "2019-12-31T23:00:00.000Z") {
        return "success"
      }
      // Not yet open: badge badge-pill badge-secondary   (Grå)
      if (event_participant.event_callroomregistration_open_time && Date.parse(event_participant.event_callroomregistration_open_time) > this.now) {
        return "secondary"
      }
      if (!event_participant.event_callroomregistration_open_time ||
        (event_participant.event_callroomregistration_open_time && Date.parse(event_participant.event_callroomregistration_open_time) < this.now)) {
        if (!event_participant.event_callroomregistration_time || Date.parse(event_participant.event_callroomregistration_time) > this.now) {
          // Open for modification:
          if (event_participant.event_callroomstatus) {
            // Open for modification - signed up: badge badge-pill badge-success   (Grønn)
            return "success"
          } else {
            // Open for modification - not signed up: badge badge-pill badge-warning   (Gul)
            if (event_participant.event_callroomstatus_modificationtime ) {
              return "info"
            } else {
              return "warning"
            }
          }
        }
      }
      // Closed...
      if (event_participant.event_callroomstatus) {
        // Closed for modification - signed up: badge badge-pill badge-success   (Grønn)
        return "success"
      } else {
        // Closed for modification - not signed up: badge badge-pill badge-danger   (Rød)
        if ( event_participant.event_callroomstatus_modificationtime ) {
          return "info"
        } else {
          return "danger"
        }
      }
    },
    pill_status_class(event_participant) {
      return "badge badge-pill badge-"+ this.status_class(event_participant);
    },
    alert_status_class(event_participant) {
      return "alert alert-"+ this.status_class(event_participant);
    }
  },
  filters: {
    formatDate_onlyHourIfToday(value) {
      var isSameDay = function(date1, date2) {
        return (
          date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()
        )
      }

      if ( typeof value === "undefined" || value.length==0) {
        return ""
      }
      var now = new Date();
      const date = new Date(value);
// if ( now > 0 ) {
//   return date.toLocaleTimeString([], { year:'numeric', month:'2-digit', day:'2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
// }
      if ( isSameDay(date, now) ) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      }
      // More than X days away? 
      if ( ((date.getTime() - now.getTime()) / (1000*3600*24)) > 3 ) {
        return date.toLocaleTimeString([], { year:'numeric', month:'2-digit', day:'2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      }
      return date.toLocaleTimeString([], { weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    },
    formatDate_onlyHour(value) {
      const date = new Date(value);
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    },
    formatUTCHoursMinutes(value) {
      const hours = value.getUTCHours().toString().padStart(2, '0');
      const minutes = value.getUTCMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    }
  }
};
</script>

<style scoped>
.table {
  display: table;
  width: 100%;
  border-collapse: collapse;
}

.row {
  display: table-row;
}

.header {
  font-weight: bold;
}

.cell {
  display: table-cell;
  padding: 5px;
  border: 1px solid black;
  white-space: nowrap;
}

.badge-success {
  background-color: #28a745 !important;
}
.badge-warning {
  background-color: #ffc107 !important;
}
.badge-danger {
  background-color: #dc3545 !important;
}
.badge-info {
  background-color: #17a2b8 !important;
}
.badge-secondary {
  background-color: #6c757d !important;
}
</style>